import {
  getString,
  getOptionalString,
} from "@surya-digital/leo-ts-types";


export namespace SurveyRespondentHeaderTextType {
  export interface NoneDTO {
    case: string;
  }
  
  export class None {
    readonly isSurveyRespondentHeaderTextTypeNone: boolean = true;
  
  
  
  
  
    toDTO(): NoneDTO {
      const dto: NoneDTO = {
        case: "NONE",
      };
      return dto;
    }
    }
  
  None.prototype.toString = function toString(): string {
    return `SurveyRespondentHeaderTextType.NONE()`;
  };
  
  export interface CustomTextDTO {
    case: string;
    customText?: string | null;
  }
  
  export class CustomText {
    readonly isSurveyRespondentHeaderTextTypeCustomText: boolean = true;
  
    readonly customText: string | null;
  
  
    constructor(
    customText: string | null = null
    ) {
      if ( customText !== undefined && customText !== null) {
        CustomText.validateCustomText(customText);
      }
      this.customText = customText;
    }
  
    static fromDTO(dto: CustomTextDTO): CustomText {
      const customText = getOptionalString(dto, "customText", InvalidSurveyRespondentHeaderTextTypeCustomTextError);
      return new CustomText(
        customText
      );
    }
  
    toDTO(): CustomTextDTO {
      const dto: CustomTextDTO = {
        case: "CUSTOM_TEXT",
      };
      if (this.customText !== undefined && this.customText !== null){
        dto.customText = this.customText;
      }
      return dto;
    }
    private static validateCustomText = (customText: string): void => {
      if(customText.trim().length === 0) {
        throw new InvalidSurveyRespondentHeaderTextTypeCustomTextCustomTextNonEmptyError(
          `Attribute customText cannot be an empty string.`
        );
      }
    }
    
  }
  
  CustomText.prototype.toString = function toString(): string {
    return `SurveyRespondentHeaderTextType.CUSTOM_TEXT(customText='${this.customText}')`;
  };
  
  export interface RespondentColumnWithFallbackTextDTO {
    case: string;
    respondentColumnName?: string | null;
    fallbackText?: string | null;
  }
  
  export class RespondentColumnWithFallbackText {
    readonly isSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackText: boolean = true;
  
    readonly respondentColumnName: string | null;
    readonly fallbackText: string | null;
  
  
    constructor(
    respondentColumnName: string | null = null, 
    fallbackText: string | null = null
    ) {
      if ( respondentColumnName !== undefined && respondentColumnName !== null) {
        RespondentColumnWithFallbackText.validateRespondentColumnName(respondentColumnName);
      }
      this.respondentColumnName = respondentColumnName;
      if ( fallbackText !== undefined && fallbackText !== null) {
        RespondentColumnWithFallbackText.validateFallbackText(fallbackText);
      }
      this.fallbackText = fallbackText;
    }
  
    static fromDTO(dto: RespondentColumnWithFallbackTextDTO): RespondentColumnWithFallbackText {
      const respondentColumnName = getOptionalString(dto, "respondentColumnName", InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameError);
      const fallbackText = getOptionalString(dto, "fallbackText", InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextError);
      return new RespondentColumnWithFallbackText(
        respondentColumnName,
        fallbackText
      );
    }
  
    toDTO(): RespondentColumnWithFallbackTextDTO {
      const dto: RespondentColumnWithFallbackTextDTO = {
        case: "RESPONDENT_COLUMN_WITH_FALLBACK_TEXT",
      };
      if (this.respondentColumnName !== undefined && this.respondentColumnName !== null){
        dto.respondentColumnName = this.respondentColumnName;
      }
      if (this.fallbackText !== undefined && this.fallbackText !== null){
        dto.fallbackText = this.fallbackText;
      }
      return dto;
    }
    private static validateRespondentColumnName = (respondentColumnName: string): void => {
      if(respondentColumnName.trim().length === 0) {
        throw new InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameNonEmptyError(
          `Attribute respondentColumnName cannot be an empty string.`
        );
      }
    }
    private static validateFallbackText = (fallbackText: string): void => {
      if(fallbackText.trim().length === 0) {
        throw new InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextNonEmptyError(
          `Attribute fallbackText cannot be an empty string.`
        );
      }
    }
    
  }
  
  RespondentColumnWithFallbackText.prototype.toString = function toString(): string {
    return `SurveyRespondentHeaderTextType.RESPONDENT_COLUMN_WITH_FALLBACK_TEXT(respondentColumnName='${this.respondentColumnName}',fallbackText='${this.fallbackText}')`;
  };
  

  export type SurveyRespondentHeaderTextType = None | CustomText | RespondentColumnWithFallbackText;

  export type SurveyRespondentHeaderTextTypeDTO = NoneDTO | CustomTextDTO | RespondentColumnWithFallbackTextDTO;

  export const fromDTO = (dto: SurveyRespondentHeaderTextTypeDTO): SurveyRespondentHeaderTextType => {
    switch (dto.case) {
      case "NONE":
          return new None();
      case "CUSTOM_TEXT":
          return CustomText.fromDTO(dto as CustomTextDTO);
      case "RESPONDENT_COLUMN_WITH_FALLBACK_TEXT":
          return RespondentColumnWithFallbackText.fromDTO(dto as RespondentColumnWithFallbackTextDTO);
      default:
        throw new InvalidSurveyRespondentHeaderTextTypeError(
            `Case ${dto.case} is not valid case of SurveyRespondentHeaderTextType.`
        );
    }
  };
}

export class InvalidSurveyRespondentHeaderTextTypeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeError";
  }
}
export class InvalidSurveyRespondentHeaderTextTypeNoneError extends InvalidSurveyRespondentHeaderTextTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeNoneError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeCustomTextError extends InvalidSurveyRespondentHeaderTextTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeCustomTextError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeCustomTextCustomTextError extends InvalidSurveyRespondentHeaderTextTypeCustomTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeCustomTextCustomTextError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeCustomTextCustomTextNonEmptyError extends InvalidSurveyRespondentHeaderTextTypeCustomTextCustomTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeCustomTextCustomTextNonEmptyError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextError extends InvalidSurveyRespondentHeaderTextTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameError extends InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameNonEmptyError extends InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextRespondentColumnNameNonEmptyError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextError extends InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextError";
  }
}

export class InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextNonEmptyError extends InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRespondentHeaderTextTypeRespondentColumnWithFallbackTextFallbackTextNonEmptyError";
  }
}
